import * as Yup from 'yup';

import { MediaHeaderTypeLabels, isMediaHeaderType, normalizeHeaderType } from './consts';

export const formFields = {
  isActive: {
    name: 'isActive',
    label: 'קמפיין פעיל',
  },
  type: {
    name: 'type',
    label: 'סוג הקמפיין',
    placeholder: 'בחר סוג קמפיין',
  },
  companies: {
    name: 'companies',
    label: 'חברות',
    placeholder: 'בחירת חברות',
  },
  messageSequence: {
    name: 'messageSequence',
    label: 'הודעות',
    messages: {
      channelType: {
        name: 'channelType',
        label: 'סוג ההודעה',
        placeholder: 'בחר סוג ההודעה',
      },
      daysAfterPrevious: {
        name: 'daysAfterPrevious',
        label: 'ימים לאחר הודעה קודמת',
      },
      templateKey: {
        name: 'templateKey',
        label: 'תבנית',
        placeholder: 'בחר תבנית',
      },
      params: {
        name: 'params',
        label: 'פרמטרים',
        placeholder: 'בחר פרמטר',
      },
      mediaUrl: {
        name: 'mediaUrl',
        label: 'מדיה',
        placeholder: 'הדבק קישור ציבורי (https://...)',
      },
    },
  },
};

// Validate that all parameters are filled when a template with parameters is selected
const validateParams = (params, templateKey, context) => {
  if (!templateKey) return true;

  // If there are no params, it's ok
  if (!params) return true;

  return !params.some((value) => !value);
};

/**
 * The media rule depends on the selected template's headerType, which lives in the WhatsApp
 * templates context rather than in the form values — so the schema is built from that list.
 * Mirrors the server-side check in MessageCampaignService.validateMessageSequenceMedia.
 */
export const createValidationSchema = (whatsappTemplates = []) =>
  Yup.object().shape({
    type: Yup.string().required('חובה לבחור סוג קמפיין'),
    companies: Yup.array().min(1, 'חובה לבחור לפחות חברה אחת'),
    messageSequence: Yup.object().shape({
      messages: Yup.array()
        .of(
          Yup.object().shape({
            channelType: Yup.string().required('חובה לבחור סוג ההודעה'),
            templateKey: Yup.string().when('channelType', {
              is: (channelType) => channelType === '3', // Whatsapp for unregistered users. TODO: change in case more whatsapp channels are added
              then: () => Yup.string().required('חובה לבחור תבנית'),
              otherwise: () => Yup.string(),
            }),
            params: Yup.mixed().when('templateKey', {
              is: (templateKey) => !!templateKey,
              then: () =>
                Yup.mixed().test('params-filled', 'חובה למלא את כל הפרמטרים', function (value) {
                  const { templateKey } = this.parent;
                  return validateParams(value, templateKey, this);
                }),
              otherwise: () => Yup.mixed(),
            }),
            mediaUrl: Yup.string().test('media-matches-template', '', function (value) {
              const { templateKey } = this.parent;
              if (!templateKey) return true;

              const template = whatsappTemplates.find((t) => t.name === templateKey);
              // Templates still loading, or an unknown template — let the server decide
              if (!template) return true;

              const headerType = normalizeHeaderType(template.headerType);
              const requiresMedia = isMediaHeaderType(headerType);
              const hasMedia = !!value;

              if (requiresMedia && !hasMedia) {
                return this.createError({
                  message: `חובה לצרף ${MediaHeaderTypeLabels[headerType]}`,
                });
              }

              if (!requiresMedia && hasMedia) {
                return this.createError({
                  message: 'התבנית שנבחרה לא תומכת במדיה',
                });
              }

              if (hasMedia && !/^https?:\/\//i.test(value)) {
                return this.createError({
                  message: 'יש להזין קישור מלא המתחיל ב-https://',
                });
              }

              return true;
            }),
          }),
        )
        .min(1, 'חובה להגדיר לפחות הודעה אחת'),
    }),
  });
